








































import { mapState } from 'vuex'
import PaidClassifiedService from '~/services/classified/paid/PaidClassifiedService'
import { LegacyUrlService } from '~/services/legacy/url/LegacyUrlService'
import { ciCredit } from '~/icons/source/regular/credit'
import { defineComponent } from '@nuxtjs/composition-api'

export default defineComponent({
  data() {
    return {
      costPerDay: null,
      minimumCredits: null,
      requiresPayment: null,
      hasMinimumCredits: null,
      neededCredits: null
    }
  },
  computed: {
    ...mapState({
      categoryId: state => state.classifieds.form.categoryId
    }),
    icons() {
      return {
        credit: ciCredit
      }
    },
    buyCreditsUrl() {
      const legacyUrlService = this.$dep(LegacyUrlService)
      return legacyUrlService.getBuyCreditsUrl()
    }
  },
  watch: {
    categoryId() {
      this.getPaymentInfo()
    }
  },
  mounted() {
    this.getPaymentInfo()
  },
  methods: {
    async getPaymentInfo() {
      if (!this.categoryId || this.categoryId === -1) {
        return
      }

      const paidClassifiedService = this.$dep(PaidClassifiedService)
      const data = await paidClassifiedService.getNewPaidClassifiedCategory(
        this.categoryId
      )

      this.requiresPayment = data.requiresPayment
      this.costPerDay = data.costPerDay
      this.minimumCredits = data.minimumCredits
      this.neededCredits = data.neededCredits
      this.hasMinimumCredits = data.hasMinimumCredits

      this.$emit('requires-payment', this.requiresPayment)
    }
  }
})
